import React, { useState, useContext, useEffect, useRef } from 'react';
import { MdVerified } from 'react-icons/md';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth, db } from '../../../../config/firebase_config.js';
import UserContext from '../../../../context/user_context';
import { LoadingSpinner } from '../../../../components/mini-components/mini-components';
import "./loginSection.css"
import { ref, get, set } from 'firebase/database';
import UserModel from "../../../../models/user_model.js"
import { getDateTime, generateQRCode } from "../../../../functions/mini_func.js";
import { errorToast, successToast } from "../../../../functions/mini_func.js"
import axios, { AxiosError } from 'axios';


const LoginSection = () => {
  const [sentOTP, setSentOTP] = useState(false);
  const [initiateOTP, setInitiateOTP] = useState(false);
  const [verifyOTP, setVerifyOTP] = useState(false);
  const [phoneNo, setPhoneNo] = useState('');
  const [otp, setOtp] = useState('');
  const [confirmObj, setConfirmObj] = useState(null);
  const [whatsappOTP, setWhatsappOTP] = useState(null);
  // const [captchaVerifier, setCaptchaVerifier] = useState(null);

  const { userInfo, setUserInfo } = useContext(UserContext);

  useEffect(() => {
    setWhatsappOTP(null);
    // const checkUserProfile = async() => {
    //   console.log("started verifying user profile");
    //   console.log(userInfo);
    //   console.log("<----------------------------------->");
    //   if(userInfo != null){
    //     const databaseRef = ref( db , `Users/${userInfo.phoneNo}`);
    //     const snapshot = await get(databaseRef);
    //     const data = snapshot.val();
    //     if(data == null){
    //         setUserInfo(null);
    //         localStorage.removeItem("user");
    //         console.log("removed user data");

    //     }
    //   }
    //   console.log("completed verifying user profile");
    // }


    // setTimeout(checkUserProfile, 1000);

    // if(userInfo != null){
    //   generateQRCode();
    // }
  }, []);


  const QRCodeImage = () => {

    const imageUrl = `data:image/png;base64,${userInfo.myQrCode}`;
    return (
      <img src={imageUrl} alt="QR Code" width={"125px"} height={"125px"} />
    );
  };

  function loginTime() {

    function _twoDigitFormat(number) {
      return number.toString().padStart(2, '0');
    }

    const now = new Date();
    const hour = _twoDigitFormat(now.getHours());
    const minute = (_twoDigitFormat(now.getMinutes()).length == 1 || _twoDigitFormat(now.getMinutes()).length == 0) ? "00" : _twoDigitFormat(now.getMinutes());
    const second = (_twoDigitFormat(now.getSeconds()).length == 1 || _twoDigitFormat(now.getSeconds()).length == 0) ? "00" : _twoDigitFormat(now.getSeconds());
    const amOrPm = now.getHours() < 12 ? 'AM' : 'PM';
    return `${hour}:${minute}:${second} ${amOrPm}`;
  }

  const sendWhatsappOTp = async () => {

    try {

      if (phoneNo.length != 10) {
        errorToast("Invalid Number", "Please enter a valid 10 digit whatsapp mobile number");
        return;
      }
      setSentOTP(true);
      setWhatsappOTP(null);
      const response = await axios.post(
        "https://authotp-jdoxig6lva-uc.a.run.app",
        // "http://127.0.0.1:5001/thediningapp-a976c/us-central1/authOTP",
        { customerNo: phoneNo }
      );
      console.log("data response : ", response.data);

      if (response.status == 200) {
        console.log("data response : ", response.data);
        setWhatsappOTP(response.data.data);
        setSentOTP(false);
        setInitiateOTP(true);
        successToast("OTP Sent succesfully", `we have sent otp to entered whatsapp no ${phoneNo}`)
        return;
      }

      errorToast("Authentication failed", response.data.toString())
      setSentOTP(false);

    } catch (e) {

      setSentOTP(false);
      // setInitiateOTP(true);
      // setWhatsappOTP("123456");

      if (axios.isAxiosError(e)) {
        const axiosError = e;
        console.log("error message --> ", axiosError.response?.data?.error);
        errorToast("Authentication failed", axiosError.response?.data?.error ?? "Something went wrong");
        return;
      }

      console.log(e);
      errorToast("Authentication failed", e.toString())

    }
  }

  const verifyWhatsappOTP = async () => {
    try {

      if (otp.length === 6 && whatsappOTP == otp) {
        setVerifyOTP(true);
        await getUserData()
        setVerifyOTP(false);
      } else {
        errorToast("Invalid OTP", "Please enter 6 digit OTP");
      }
    } catch (e) {
      setVerifyOTP(false);
      console.error('Phone authentication failed', e);
      errorToast("Authentication failed", e.toString());
    }
  }

  const getUserData = async () => {
    const databaseRef = ref(db, `Users/${phoneNo}`);
    const snapshot = await get(databaseRef);
    if (snapshot.exists()) {
      const data = snapshot.val()
      setUserInfo(UserModel.fromJson(data));
      localStorage.setItem("user", JSON.stringify(UserModel.fromJson(data).toJson()))
    } else {
      const time = new Date();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();
      const qrCodeNo = `MY${minutes}${seconds}${phoneNo.substring(6)}`;
      const qrData = `${phoneNo}<?>admin@thediningapp.com<?>${""}<?>${qrCodeNo}`;
      console.log(`>---------  ${qrData}  -----------< `)
      const base64Image = await generateQRCode(qrData);

      const userInfo = {
        balance: "0",
        date: getDateTime(false),
        dateTime: getDateTime(true),
        emailId: "admin@thediningapp.com",
        firstName: "",
        gender: "",
        imageURL: "default",
        myQRCode: base64Image,
        myQRCodeNo: qrCodeNo,
        password: "123456",
        phoneNo: phoneNo,
        restaurantAddress: '',
        restaurantBarNo: "",
        restaurantGstNo: "",
        restaurantId: "",
        restaurantKitchenNo: "",
        restaurantName: "",
        restaurantPhoneNo: "",
        search: "",
        status: "",
        statusType: "Active",
        time: loginTime(),
        type: "",
        userType: "U",
        priorityUser: "N",
        companyName: ""
      };

      await set(databaseRef, userInfo);
      setUserInfo(UserModel.fromJson(userInfo));
      localStorage.setItem("user", JSON.stringify(UserModel.fromJson(userInfo).toJson()));
    }
  }

  const handleLoginButton = async (response) => {

    console.log("check once");
    try {
      signInWithPhoneNumber(auth, `+91${phoneNo}`, response)
        .then((res) => {
          console.log("this might work");
          setConfirmObj(res);
          setSentOTP(false);
          setInitiateOTP(true);
        })
        .catch((error) => {
          errorToast("Authentication failed", error.toString())
          console.error('Phone authentication failed', error);
          setSentOTP(false);
        });

    } catch (e) {
      setSentOTP(false);
      console.log(e);
    }
  };

  const handleResendOTP = async (response) => {
    console.log("check once")

    if (phoneNo.length === 10) {
      try {
        setSentOTP(true);
        // onCaptchVerify();
        const appVerifier = window.recaptchaVerifier;
        signInWithPhoneNumber(auth, `+91${phoneNo}`, appVerifier)
          .then((res) => {
            console.log("this might work");
            setConfirmObj(res);
            setSentOTP(false);
            setInitiateOTP(true);
          })
          .catch((error) => {
            // errorToast("Authentication failed" , error.toString())
            console.error('Phone authentication failed', error);
            setSentOTP(false);
          });

      } catch (e) {
        setSentOTP(false);
        console.log(e);
      }
    } else {
      errorToast("Invalid Mobile Number", "Please enter 10 digit Mobile Number");
    }
  };


  function onInvisibleCaptchVerify() {
    console.log("<______________________check once");
    window.recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-container',
      {
        size: "invisible",
        callback: (response) => {
          console.log(response);
          handleLoginButton(window.recaptchaVerifier);
        },
        "expired-callback": () => {
          console.log("Resend OTP");
        },
        "error-callback": (error) => {
          console.error("reCAPTCHA error:", error);
        },
      },
      auth
    );

    try {
      if (phoneNo.length === 10) {
        setSentOTP(true);
        window.recaptchaVerifier.verify();
      } else {
        errorToast("Invalid Mobile Number", "Please enter 10 digit Mobile Number");
        setSentOTP(false);
      }
    } catch (e) {
      setSentOTP(false);
      console.log(e);
      errorToast("something went wrong", e.toString());
    }
  }

  function setupRecaptcha() {
    try {
      const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
        'size': 'normal',
        'callback': (response) => {
          console.log(response);
          // setCaptchaVerifier(recaptchaVerifier);
          handleLoginButton(recaptchaVerifier);
          console.log("check this once ra ayyya.... recapthacha verified");
        },
        'expired-callback': (e) => {
          // Response expired. Ask user to solve reCAPTCHA again. 
          //   console.log( "<-- captcha mawa -->", e , "<------->");
          // errorToast("Authentication Failed" , e.toString());

        }
      }, auth);

      recaptchaVerifier.render();
    } catch (e) {
      console.log(e);
      // errorToast("Authentication Failed" , e.toString());
    }

  }

  function setupResendRecaptcha() {
    const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container-resend', {
      'size': 'normal',
      'callback': (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        console.log(response);
        // setCaptchaVerifier(recaptchaVerifier);
        handleLoginButton(recaptchaVerifier);
        console.log("check this once ra ayyya.... recapthacha verified");
      },
      'expired-callback': () => {
        // Response expired. Ask user to solve reCAPTCHA again.

      }
    }, auth);

    recaptchaVerifier.render();
  }


  const verifyOTPFunc = async () => {
    try {
      if (otp.length === 6) {
        setVerifyOTP(true);
        await confirmObj.confirm(otp)
          .then(async (result) => {
            console.log('Phone authentication successful');
            await getUserData()
            setVerifyOTP(false);
          })
          .catch((error) => {
            console.error('Phone authentication failed', error);
            errorToast("Authentication Failed", error.message)
            setVerifyOTP(false);
          });

      } else {
        errorToast("Invalid OTP", "Please enter 6 digit OTP");
      }
    } catch (e) {
      setVerifyOTP(false);
      console.error('Phone authentication failed', e);
    }
  };


  const signOut = () => {
    setUserInfo(null);
    setPhoneNo('');
    localStorage.removeItem("user");
    setInitiateOTP(false);
  }

  const checkUserProfile = async () => {
    console.log("started verifying user profile");
    console.log(userInfo);
    console.log("<----------------------------------->");
    if (userInfo != null) {
      const databaseRef = ref(db, `Users/${userInfo.phoneNo}`);
      const snapshot = await get(databaseRef);
      const data = snapshot.val();
      if (data == null) {
        setUserInfo(null);
        localStorage.removeItem("user");
        console.log("removed user data");

      }
    }
    console.log("completed verifying user profile");
  }

  setTimeout(checkUserProfile, 500);

  return (
    <div className='checkout-item-container login-container'>
      {userInfo == null ? (
        <>
          <h3>User Login</h3>
          <span style={{ fontSize: 12, lineHeight: 1.5 }} >Login  with your <span style={{ fontWeight: "bold", color: "white", fontSize: 12.5, paddingLeft: 4, paddingRight: 4 }}> Whatsapp Phone Number </span> to proceed with payment and enjoy exclusive discounts</span>
          <div className='mobile-container'>
            <p>Phone Number</p>
            <input
              type='tel'
              placeholder='Enter Whatsapp Phone Number'
              maxLength={10}
              onChange={(e) => setPhoneNo(e.target.value)}
              readOnly={initiateOTP}
            />

            {/* {
                // firebase code
               !initiateOTP &&    // confirmObj == null &&
            <div id='recaptcha-container'></div>
            } */}
          </div>
          {initiateOTP && (
            <div className='otp-container'>
              <p>OTP</p>
              <input
                type='number'
                placeholder='******'
                maxLength={6}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>
          )}
          {sentOTP || verifyOTP ? (
            <LoadingSpinner />
          ) : (
            <button
              onClick={initiateOTP ? verifyWhatsappOTP : sendWhatsappOTp}
              className='text-black'
            // onClick={initiateOTP ? verifyOTPFunc : onInvisibleCaptchVerify} // firebase
            >
              {initiateOTP ? 'Verify OTP' : 'Send Code'}
            </button>
          )}

          {/* <div id='recaptcha-container-resend'></div>
          {
            (
              initiateOTP && (
                <div className='resend-otp'>
                  <p>Didn't you have recieved OTP</p>
                  <span onClick={()=>{
                    onInvisibleCaptchVerify()
                  }}> Resend OTP</span>
                </div>
              )
          )
          } */}
        </>
      ) : (
        <>
          <h3>Account Details</h3>
          <h5>Phone Number</h5>
          <div className='account-details'>
            <p>+91 {userInfo.phoneNo}</p>
            <span>
              <MdVerified />
            </span>
          </div>
          <div className='qr-image'>
            <QRCodeImage />
          </div>
          <button onClick={signOut} className='text-black'>Sign Out</button>
        </>
      )}
    </div>
  );
};

export default LoginSection;
